import { localize, Message, MessageTranslator } from '@oneflowab/pomes';
import { useSelector } from 'react-redux';

import { getCurrentLanguageSelector } from 'reducers/i18n';
import { useAiInsightsContext } from 'contexts/ai-insights-context';
import type { PlaybookValues } from '../../../types';
import { getInsightTexts } from '../../../texts';

type Props = {
  values: PlaybookValues,
  insightType: string,
  message: MessageTranslator,
};

const PlaybookComponent: React.FC<Props> = ({
  values, insightType, message,
}: Props): React.ReactElement => {
  const { playbookTemplateType } = useAiInsightsContext();
  const currentLanguage = useSelector(getCurrentLanguageSelector) || 'en';
  const insightsTexts = getInsightTexts(message, currentLanguage);

  if (insightsTexts[playbookTemplateType][insightType]) {
    return insightsTexts[playbookTemplateType][insightType].getPlaybookText(values);
  }

  return (
    <Message
      id="Missing"
      comment="Fallback text"
    />
  );
};

export const Playbook = localize(PlaybookComponent);
